import routerOptions0 from "F:/Github/dexon-technology/frontend/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.153.0_@vue+compiler-sfc@3.5.44_confbox@0.3.1_db0@0.3.4_dote_ryahtarybgy4ghlnucizrwdwwu/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}